import React from "react";
// import { BrowserRouter as Router } from "react-router-dom";
import { HashRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Routers from "./Routers";
import "./Styles/style.css";
import { ToastContainer } from "react-toastify";
import { TOAST_CONTAINER_CONFIG } from "./utils/constant";

const App = () => {
  return (
    <>
      <HelmetProvider>
        <ToastContainer {...TOAST_CONTAINER_CONFIG} />
        <Router>
          <Routers />
        </Router>
      </HelmetProvider>
    </>
  );
};

export default App;
